export default "__VITE_ASSET__6aff7017__"